import { h } from 'preact';
import { useState } from 'preact/hooks';
import { route } from 'preact-router';
import { t } from '../i18n.js';
import LanguageSwitcher from '../components/shared/LanguageSwitcher.jsx';

export default function ResetPasswordView() {
  const token = new URLSearchParams(window.location.search).get('token');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < 8) {
      setError(t('auth.passwordTooShort'));
      return;
    }
    if (newPassword !== confirmPassword) {
      setError(t('auth.passwordMismatch'));
      return;
    }

    setLoading(true);
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword })
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        setError({
          same_password: 'Kies een ander wachtwoord dan je huidige.',
          password_recently_used: 'Dit wachtwoord heb je kort geleden al gebruikt. Kies een ander.',
          invalid_input: 'Je nieuwe wachtwoord moet 8 tot 72 tekens zijn.',
        }[body.error] || t('auth.invalidResetToken'));
      } else {
        setDone(true);
      }
    } catch (_) {
      setError(t('auth.invalidResetToken'));
    }
    setLoading(false);
  };

  return (
    <div class="login-page">
      <div style="position:absolute;top:20px;right:20px">
        <LanguageSwitcher />
      </div>

      <div class="login-card">
        <div class="login-logo">S</div>
        <h1 class="login-title">{t('auth.resetPasswordTitle')}</h1>

        {done ? (
          <>
            <p style="color:var(--color-text-muted);font-size:14px;line-height:1.6;margin-bottom:24px">
              {t('auth.resetPasswordSuccess')}
            </p>
            <button
              class="btn btn-primary btn-lg"
              style="width:100%"
              onClick={() => route('/login')}
            >
              {t('auth.backToLogin')}
            </button>
          </>
        ) : (
          <>
            <p class="login-subtitle">{t('auth.resetPasswordSubtitle')}</p>
            {error && <div class="alert alert-error">{error}</div>}
            {!token ? (
              <div class="alert alert-error">{t('auth.invalidResetToken')}</div>
            ) : (
              <form onSubmit={handleSubmit} noValidate>
                <div class="form-group">
                  <label class="form-label">{t('auth.newPassword')}</label>
                  <input
                    class="form-input"
                    type="password"
                    value={newPassword}
                    onInput={(e) => setNewPassword(e.target.value)}
                    autocomplete="new-password"
                    autoFocus
                  />
                </div>
                <div class="form-group">
                  <label class="form-label">{t('auth.confirmPassword')}</label>
                  <input
                    class="form-input"
                    type="password"
                    value={confirmPassword}
                    onInput={(e) => setConfirmPassword(e.target.value)}
                    autocomplete="new-password"
                  />
                </div>
                <button
                  class="btn btn-primary btn-lg"
                  style="width:100%;display:flex;align-items:center;justify-content:center;gap:8px"
                  type="submit"
                  disabled={loading}
                >
                  {loading && <span class="btn-spinner" />}
                  {loading ? t('common.loading') : t('auth.resetPasswordButton')}
                </button>
              </form>
            )}
            <p style="text-align:center;margin-top:16px">
              <a
                href="/login"
                style="font-size:14px;color:var(--color-primary);text-decoration:none"
                onClick={(e) => { e.preventDefault(); route('/login'); }}
              >
                {t('auth.backToLogin')}
              </a>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
